module.exports = __webpack_public_path__ + "static/img/tupian_wenjian.1e088040.png";